{
  "navbar": {
    "link": {
      "home": "Home"
    }
  },
  "appCore": {
    "common": {
      "yes": "Tak",
      "no": "Nie",
      "errors": {
        "notEmpty": "To pole nie może być puste"
      }
    },
    "footer": {
      "state": "regulamin",
      "policy": "polityka prywatności"
    },
    "apps": {
      "popUp": {
        "privacyPolicy": {
          "header": "Chwilka, jeszcze tylko to:",
          "text": "Oświadczam, że zapoznałem/am się z {state} oraz {policy} i wyrażam zgodę na ich postanowienia.",
          "state": "regulaminem",
          "policy": "polityką prywatności",
          "decline": "Anuluj",
          "accept": "Tak, zgadzam się"
        }
      },
      "event": {
        "common": {
          "underPictureText": "Pokaż nam jak się bawisz, pośmiejemy się jutro!",
          "back": "Powrót"
        },
        "mirrorWedding": {
          "sendText": "PRZEŚLIJ I WYDRUKUJ",
          "sendingText": "PRZESYŁANIE"
        },
        "wedding": {
          "sendText": "PRZEŚLIJ",
          "sendingText": "WYSYŁANIE",
          "1": {
            "sendText": "PRZEŚLIJ ZDJĘCIA/WIDEO"
          }
        },
        "gallery": {
          "header": "Aktualna galeria wydarzenia!",
          "name": "Galeria",
          "button": "Galeria zdjęć",
          "subtext": "podgląd przesłanych zdjęć",
          "moreFiles": "Więcej zdjęć",
          "changeView": "Zmień widok",
          "loadedFiles": "Załadowano pliki",
          "noNewFiles": "Brak nowych plików do załadowania. Jeśli szukasz przesłanych zdjęć, mogą nie być na końcu, lecz w środku galerii."
        },
        "sender": {
          "errors": {
            "wrongFiles": "Możesz przesłać maksymalnie 20 zdjęć lub wideo o łącznej wielkości nieprzekraczającej 1 GB",
            "wrongFilesWithWish": "Możesz przesłać maksymalnie 1 zdjęcie o łącznej wielkości nieprzekraczającej 1 GB",
            "default": "Błąd w przesyle plików",
            "notFiles": "Nie wybrano plików"
          },
          "infos": {
            "emptyWish": "Proszę wpisać życzenia",
            "sendedFiles": "Przesłano wszystkie pliki. Dziękujemy :)",
            "sendedProcessing": "Pliki pojawią się w galerii po przetworzeniu przez serwer",
            "fileUnsupported": "Zdjęcie poprawnie załadowane. Po wysłaniu znajdziesz je w galerii.",
            "sendingProblem": {
              "sended": "Wysłano",
              "from": "z",
              "files": "plików",
              "sendingError": "Błąd podczas przesyłania.",
              "checkFiles": "Sprawdź plik i prześlij go ponownie."
            }
          },
          "button": "Prześlij zdjęcia/wideo",
          "or": "lub",
          "yourWishes": "Twoje życzenia"
        }
      },
      "rsvp": {
        "versions": {
          "1": {
            "invitationText": "mają zaszczyt zaprosić",
            "placeText": "na uroczystość zawarcia związku małżeńskiego, która odbędzie się",
            "yearAndHour": "roku o godzinie",
            "in": "w",
            "0": {
              "placeText": "na uroczystość zawarcia związku małżeńskiego, która odbędzie się"
            },
            "1": {
              "placeText": "uroczystość zawarcia związku małżeńskiego oraz przyjęcie weselne, które odbędzie się"
            },
            "2": {
              "partyText": "PRZYJĘCIE WESELNE",
              "weddingPlace": "Zobacz kościół na mapie",
              "partyPlace": "Zobacz Salę na mapie"
            }
          },
          "2": {
            "wedding": "Będzie Ślub!",
            "year": "roku",
            "hour": "o godz.",
            "weddingPath": "Kliknij, aby wyznaczyć trasę między Kościołem, a salą weselną:",
            "partyWelcome": "Już nie możemy się doczekać, aby przywitać Was na naszym weselu!"
          }
        },
        "components": {
          "form": {
            "confirmArrival": "POTWIERDŹ SWOJE PRZYBYCIE",
            "main": {
              "addAnotherGuest": "Dodaj kolejnego gościa",
              "addGuest": "Potwierdź przybycie",
              "sendRsvp": "Wyślij potwierdzenie",
              "edit": "EDYTUJ",
              "name": "IMIĘ",
              "surname": "NAZWISKO",
              "present": "Będę na weselu",
              "notPresent": "Nie będę na weselu",
              "notify": {
                "error": "Błąd w przesyle danych",
                "positive": "Wysłano dane. Dziękujemy :)",
                "notFilled": "Nie wypełniono wszystkie wymagane pola"
              }
            },
            "guest": {
              "guestData": "Podaj swoje imię i nazwisko:",
              "name": "Imię",
              "surname": "Nazwisko",
              "willBePresent": "Czy pojawisz się na naszym weselu?",
              "save": "Zapisz"
            },
            "verions": {
              "2": {
                "historyWish": "Chcielibyśmy, abyście stali się częścią naszej wspólnej historii.",
                "dueToInfo": "Uprzejmie prosimy o potwierdzenie swojej obecności do dnia {dueToTime} poprzez wypełnienie arkusza poniżej.",
                "confirmArrival": "Potwierdzenie przybycia",
                "guest": {
                  "guestData": "Podaj swoje imię i nazwisko:",
                  "willBePresent": "Czy potwierdzasz swoją obecność?"
                }
              }
            }
          },
          "weddingWishes": {
            "title": "ŻYCZENIA PARY MŁODEJ"
          },
          "clockWidget": {
            "title": "Do ślubu pozostało",
            "clock": {
              "days": "dni",
              "hours": "godzin",
              "minutes": "minut",
              "seconds": "sekund"
            }
          }
        }
      },
      "components": {
        "inputs": {
          "inputCheckboxTrueFalseSelect": {
            "selectLabel": "Wybierz jedną z poniższych opcji:"
          }
        },
        "sender": {
          "sendLabel": "Dodaj zdjęcia/wideo",
          "sendWithWishLabel": "Dodaj jedno zdjęcie i życzenia",
          "from": "z",
          "processing": "Przetwarzanie",
          "notToGallery": "Nie pokazuj w galerii"
        },
        "gks": {
          "findTable": "Znajdź swój stół"
        },
        "bingo": {
          "text": "Zagraj w BINGO!"
        }
      },
      "gks": {
        "header": "Plan stołów",
        "foundPlace": "Znajdź swoje miejsce...",
        "namePlaceholder": "Wpisz swoje imię i nazwisko",
        "personNotFound": "Nie Znaleziono Wyszukiwanej Osoby",
        "samePersonFound": "Znaleziono więcej osób z podobnym imieniem i nazwiskiem, proszę kontynuuj wpisywanie...",
        "table": "Stół",
        "footer": "...A potem baw się do białego rana!"
      }
    }
  },

  "loremIpsum": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,"
}
